import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchWiToolAssetsWithRules = async () => {
  const response = await fetch(
    `${WiMuleSQL}/api/Maintenance/GetWiToolAssetsWithRules`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (!response.ok) {
    throw new Error(`HTTP Error: ${response.status}`);
  }

  return response.json();
};

export const useGetWiToolAssetsWithRules = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getWiToolAssetsWithRules"],
    queryFn: fetchWiToolAssetsWithRules,
    staleTime: 3600000, // Cache results for 1 hour
  });

  return { data, isLoading, isError, error };
};
